<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="ad-revenue-breakdown-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Ad Revenue Breakdown
                        </h4>
                    </div>

                    <loading-spinner v-if="loading"/>

                    <div v-else class="modal-body">
                        <table class="table table-striped table-condensed">
                            <thead>
                            <tr>
                                <th>
                                    Order
                                </th>

                                <th>
                                    Channel
                                </th>

                                <th>
                                    Revenue
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="row in rows">
                                <td>
                                    <a href="#" @click.prevent="navigate(row.order_id)">
                                        HG{{ row.order_id }}
                                    </a>
                                </td>

                                <td>
                                    {{ row.channel_name }}
                                </td>

                                <td>
                                    {{ row.ad_revenue | price }}
                                </td>
                            </tr>
                            </tbody>

                            <tfoot>
                            <tr>
                                <td></td>

                                <td></td>

                                <td>
                                    {{ totalRevenue | price }}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner},

        props: {
            company: {
                required: true
            },

            year: {
                required: true
            },

            portal: {
                required: false
            }
        },

        data() {
            return {
                rows: null,

                loading: true
            }
        },

        mounted() {
            this.listenForClose()
        },

        watch: {
            company() {
                this.load()
            },

            year() {
                this.load()
            },

            portal() {
                this.load()
            }
        },

        computed: {
            totalRevenue() {
                return this.rows.reduce((total, row) => row.ad_revenue + total, 0)
            }
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            load() {
                this.loading = true

                let filters = [
                    {dimension: 'company_id', value: this.company}
                ]

                if (this.portal) {
                    filters.push({dimension: 'portal_id', value: this.portal})
                }

                return http.post('/api/v1/reports/dashboard', {
                    start: this.year + '-01-01',
                    end: this.year + '-12-31',
                    metrics: ['ad_revenue'],
                    dimensions: ['order_id', 'channel_id', 'channel_type', 'channel_name'],
                    filters
                }).then(response => {
                    this.rows = response.data.data

                    this.loading = false
                })
            },

            navigate(order) {
                $(this.$el).modal('hide')

                this.$router.push('/companies/' + this.company + '/orders/' + order)
            }
        }
    }
</script>
